import React from "react";

import BaseDropdown from "components/form/BaseDropdown";

import Context from "../Context";
import { ValueComponentProps } from "../types";

interface BooleanValueProps extends ValueComponentProps {
  value?: boolean;
}

const BooleanValue = ({ id, value = true }: BooleanValueProps): JSX.Element => {
  const context = React.useContext(Context);
  const { labels, dispatchAction } = context;

  const values = ["true", "false"].map((v) => ({
    id: v,
    label: labels.rule.value.boolean.options[v],
    selected: value === (v === "true"),
  }));

  return (
    <BaseDropdown
      required
      status="valid"
      singleSelectionToggle={false}
      label={labels.rule.value.boolean.label}
      placeholder={labels.rule.value.boolean.placeholder}
      values={values}
      onChange={(selected) => {
        if (selected && !Array.isArray(selected) && selected.id) {
          dispatchAction({
            type: "set-value",
            id,
            value: selected.id === "true",
          });
        } else {
          dispatchAction({ type: "set-value", id, value: null });
        }
      }}
    />
  );
};

export default React.memo(BooleanValue);
